import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";

type ConfirmationDialogProps = {
  messages: string[];
  doConfirm: () => void;
  doReject: () => void;
  type?: string;
};

export function ConfirmationDialog({ messages, doConfirm, doReject, type }: ConfirmationDialogProps) {
  let isDialogOpen = messages.length > 0;

  let dialogMessages = (
    <div>
      {messages.map((message, index) => (
        <div key={"confirm-" + index} style={{ marginBottom: "8px" }} dangerouslySetInnerHTML={{ __html: message }} />
      ))}
    </div>
  );

  if (type === "confirmPopup" && messages.length === 1) {
    dialogMessages = <div dangerouslySetInnerHTML={{ __html: messages[0] }} />;
  }

  return (
    <Dialog
      open={isDialogOpen}
      onClose={doReject}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{type === "confirmTurn" && "Are you sure?"}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description" component={"div"} style={{ whiteSpace: "pre-line" }}>
          {dialogMessages}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={doConfirm} autoFocus>
          {type === "confirmPopup" ? "ok" : "Confirm"}
        </Button>
        {type === "confirmTurn" && <Button onClick={doReject}>I changed my mind</Button>}
      </DialogActions>
    </Dialog>
  );
}
